import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
    mode: 'history',

    //切换页面回到顶部
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: "/",
            redirect: "/index"
        },
        {
            path: '/Home',
            component: () =>
                import ('../view'),
            children: [
                {
                    path: '/index',
                    component: () =>
                        import ("../view/Home.vue"),
                    meta: {title: "首页", keepAlive: false}
                },
                {
                    path: '/result',
                    component: () =>
                        import ("../view/result.vue"),
                    meta: {title: "证书查询结果", keepAlive: false}
                },
                {
                    path: '/resultUser',
                    component: () =>
                        import ("../view/resultUser.vue"),
                    meta: {title: "成员单位查询结果", keepAlive: false}
                },
            ]
        }
    ]
})
